export const LikesCountMixin = {
    computed:{
        LikesCount() {
            return this.data.likes_count ?? 0
        },
    }
}
